export const iconFontAwesomeUsersPeoplePersonWalkingArrowLoopLeft = (
	<i className="fa-solid fa-person-walking-arrow-loop-left"></i>
);
